<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="核算月份：">
                <el-date-picker v-model="searchForm.countBatch" type="month" placeholder="选择结算月份" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <el-form-item label="薪酬状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="0" label="未发薪酬"></el-option>
                    <el-option value="1" label="已发薪酬"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属业务员：">
                <el-select v-model="searchForm.yewuId"   filterable>
                    <el-option v-for="item in yewuData" :value="item.id" :key="item.id" :label="item.name+'（'+item.sysUserAccountName+'）'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getOrderSettlementListHandler" icon="el-icon-search">搜索查询</el-button>
                 <el-button  type="danger"  @click="getOrderSettlementListHandlerss"  icon="el-icon-s-ticket">手动更新本月数据</el-button>
                <!-- <el-button type="success" @click="confirmExportDialogVisible = true"  icon="el-icon-download">导出Excel</el-button> -->
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="name" label="业务员名称"></el-table-column>
            <el-table-column prop="countMonth" label="核算月份"  align="center" ></el-table-column>
            <!-- <el-table-column prop="createTime" label="更新时间"  width="120"></el-table-column> -->
            <el-table-column prop="soldPrice" label="本月销售额（元）"   align="center" ></el-table-column>
             <el-table-column   align="center"  label="本月总利润（元）" >
                    <template v-slot="scope">
                   <el-tooltip :content="scope.row.createTimes">
                        <p style="color:hotpink"> {{scope.row.onMonth}}</p>
                    </el-tooltip>
                    
                     </template>
              </el-table-column>
            <el-table-column prop="soldToDayPrice" label="昨天销售额（元）"  align="center" ></el-table-column>
            <el-table-column prop="upDay" label="昨天总利润（元）"  align="center" ></el-table-column>            
            <el-table-column prop="simTotal" label="总卡数"  align="center" ></el-table-column>
            <el-table-column prop="simActived" label="已激活卡数"  align="center" ></el-table-column>
            <el-table-column prop="simActiving" label="在用卡数"  align="center" ></el-table-column>
             <el-table-column prop="agentCount" label="直属代理总数"  align="center" ></el-table-column>
              <el-table-column prop="stateName" label="薪酬状态"  align="center" ></el-table-column> 
              <el-table-column prop="salePrice" label="已发薪酬"  align="center" ></el-table-column> 
            <el-table-column prop="countTime" label="发放时间"></el-table-column> 
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.state == 0" type="success" @click="settlementHandler(scope.row)">核算薪酬</el-button>
                </template>                
            </el-table-column> 
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrderFinancialHandle">确 定</el-button>
            </span>
        </el-dialog>

         <el-dialog :append-to-body="true"  title="核算业务员佣金" :visible.sync="simHandleVisibale2" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"  label-width="120px">
                 <el-form-item label="总薪酬（元）：" >
                        <el-input v-model.trim="salePrice" disabled  clearable></el-input>
                    </el-form-item> 
                  <el-form-item label="发放薪酬比列：" >
                        <el-input v-model.trim="searchForm.salePriceP"   placeholder="比如百分之十的佣金比列 请填 10 即可" clearable  style="width:280px">
                        </el-input>
                    </el-form-item> 
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="fayongjing">确 定</el-button>
            </div>
        </el-dialog>      
    </div>
</template>
<script>
import {getOrderSettlementLists, orderSettlements, exportFinancialInfo} from '@/api/finance.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                countBatch: '',
                state: '',
                agentName: '',
                yewuId:'',
                salePriceP:''
            },
            simHandleVisibale2:false,
            yewuIds:'',
            salePrice:'',
            yewuData:[],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            confirmExportDialogVisible:false//导出确认框
        }
    },
    methods: {
         cancel(){   
            this.simHandleVisibale2=false;         
        },
        getOrderSettlementListHandlerss(){
             this.$confirm('此操作等待时间比较久，轮询每天会定时更新。 确定要手动操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               

                common.sysRequest('financial/order/update/yewu', {}, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getOrderSettlementListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => {});
        },
        getOrderSettlementListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getOrderSettlementLists(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        fayongjing(){
             var data = {
                 id:this.yewuIds,
                 salePrice:this.salePrice,
                 salePriceP:this.searchForm.salePriceP
             }
            orderSettlements(data).then(res => {
                if(res.data.code == 200){     
                   this.simHandleVisibale2=false;            
                    this.$message.success(res.data.message)
                    this.getOrderSettlementListHandler();
                }else{
                    this.$message.error(res.data.message)
                }
            })   
        },
        settlementHandler(row){

            this.yewuIds=row.id;
            this.salePrice=row.onMonth;
            this.simHandleVisibale2=true;
                    
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getOrderSettlementListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getOrderSettlementListHandler();
        },
        exportOrderFinancialHandle(){
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            exportFinancialInfo(data).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));     
        }         
    },
    created () {
        common.getAgentListOptionComs(this, 'yewuData');
        this.getOrderSettlementListHandler();
    }
}
</script>
<style>

</style>